<template>
  <div class="form-wrapper">
    <form @submit="handleSubmit">
      <label for="user-id">User ID</label>
      <input
        id="user-id"
        v-model="userID"
        autofocus
        placeholder="Enter user id or email"
        required
        type="text"
        class="border-2"
      />
      <label for="cohort-id">Frequency Hours (set 0 to unsubscribe)</label>
      <input
        v-model="frequency"
        class="border-2"
        type="number"
        min="0"
        max="24"
      />

      <button
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-blue"
      >
        Update Frequency
      </button>
    </form>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      userID: "",
      frequency: 2,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.updateFrequency()
    },
    updateFrequency() {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}user`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: {
          notification_frequency_hours: this.frequency,
          user_id: this.userID,
        },
      })
        .then(res => {
          console.log(res)
          this.$noty.success("Successfully updated notification frequency!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(() => {
          this.$noty.error("Failed to update frequency!", {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  /* text-align: center; */
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
button {
  display: block;
  margin: 10px auto;
  text-align: center;
}
</style>
